/* ============================================================
   Craft Com v2 : petites interactions de la refonte (oct. 2026)
   Compteurs, graphique qui se remplit, note moyenne des avis,
   lien actif du menu. Rien ne suit le curseur, rien n'est lié
   au scroll, aucune vidéo ni aucun son ne se lance tout seul.
   ============================================================ */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---- compteurs ---- */
  function fmt(n) { return n.toLocaleString('fr-FR'); }
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      cio.unobserve(e.target);
      var el = e.target, to = parseFloat(el.getAttribute('data-count')) || 0;
      if (reduce) { el.textContent = fmt(to); return; }
      var t0 = null, d = 1200;
      function f(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / d);
        el.textContent = fmt(Math.round(to * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(f);
      }
      requestAnimationFrame(f);
    });
  }, { threshold: 0.6 });
  [].forEach.call(document.querySelectorAll('[data-count]'), function (el) { cio.observe(el); });

  /* ---- graphique d'exemple ---- */
  var oio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('on'); oio.unobserve(e.target); }
    });
  }, { threshold: 0.3 });
  [].forEach.call(document.querySelectorAll('.sx-dash'), function (el) { oio.observe(el); });

  /* ---- note moyenne des avis ---- */
  var grid = document.getElementById('revGrid'), sum = document.getElementById('revSum');
  if (grid && sum) {
    var update = function () {
      var revs = grid.querySelectorAll('.rev');
      if (!revs.length) return;
      var total = 0;
      [].forEach.call(revs, function (r) { total += r.querySelectorAll('.stars svg').length; });
      var avg = total / revs.length;
      sum.innerHTML = '<span class="rev-sum-stars" aria-hidden="true">★★★★★</span><b>' +
        avg.toFixed(1).replace('.', ',') + ' / 5</b><span>sur ' + revs.length + ' avis</span>';
      sum.hidden = false;
    };
    new MutationObserver(update).observe(grid, { childList: true });
    update();
  }

  /* ---- avis : pas de tiret cadratin dans les intitulés ---- */
  if (grid) {
    var clean = function () {
      [].forEach.call(grid.querySelectorAll('.rev-by .t'), function (t) {
        if (t.textContent.indexOf('—') !== -1) t.textContent = t.textContent.replace(/\s*—\s*/g, ' · ');
      });
    };
    new MutationObserver(clean).observe(grid, { childList: true });
    clean();
  }

  /* ---- lien actif dans le menu ---- */
  var path = location.pathname.replace(/\/$/, '');
  [].forEach.call(document.querySelectorAll('#navlinks a'), function (a) {
    var h = a.getAttribute('href') || '';
    if (h.indexOf('#') !== -1) return;
    h = h.replace(/\/$/, '');
    if (h && h === path) a.classList.add('active');
  });
})();

/* ---- page Services : prestations rangées par catégories ---- */
(function () {
  var grid = document.getElementById('svcGrid');
  if (!grid || grid.dataset.cats) return;
  var CATS = [
    { name: 'Visuels', ids: ['flyer', 'cartevisite', 'snap'] },
    { name: 'Menus', ids: ['print', 'board'] },
    { name: 'Vidéos', ids: ['motion', 'motionvo', 'video'] },
    { name: 'Sites internet', ids: ['siteessentiel', 'sitepro', 'sitemachine', 'shopify'] },
    { name: 'Sur mesure', ids: ['autres'] }
  ];
  var cards = {};
  [].forEach.call(grid.querySelectorAll('.svc[data-id]'), function (c) { cards[c.dataset.id] = c; });
  if (!Object.keys(cards).length) return;
  grid.dataset.cats = '1';
  grid.classList.remove('services-grid');
  grid.classList.add('svc-cats');
  var nav = document.createElement('div');
  nav.className = 'svc-jump';
  grid.appendChild(nav);
  var used = {};
  CATS.forEach(function (cat, i) {
    var list = cat.ids.filter(function (id) { return cards[id]; });
    if (!list.length) return;
    var id = 'cat-' + i;
    var box = document.createElement('div');
    box.className = 'svc-cat'; box.id = id;
    var h = document.createElement('h3');
    h.className = 'svc-cat-title';
    h.textContent = cat.name;
    var g = document.createElement('div');
    g.className = 'services-grid';
    list.forEach(function (k) { g.appendChild(cards[k]); used[k] = 1; });
    box.appendChild(h); box.appendChild(g);
    grid.appendChild(box);
    var a = document.createElement('a');
    a.href = '#' + id; a.textContent = cat.name;
    nav.appendChild(a);
  });
  /* une prestation non classée reste visible à la fin */
  var rest = Object.keys(cards).filter(function (k) { return !used[k]; });
  if (rest.length) {
    var g2 = document.createElement('div'); g2.className = 'services-grid';
    rest.forEach(function (k) { g2.appendChild(cards[k]); });
    grid.appendChild(g2);
  }
  var st = document.createElement('style');
  st.textContent =
    '.svc-cats{display:block}' +
    '.svc-jump{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:34px}' +
    '.svc-jump a{padding:10px 16px;border-radius:8px;border:1px solid var(--hair);background:rgba(255,255,255,.03);color:var(--ice);font-size:.88rem;font-weight:600;transition:border-color .3s,background .3s}' +
    '.svc-jump a:hover{border-color:var(--turq);background:rgba(47,230,224,.08)}' +
    '.svc-cat{margin-bottom:46px;scroll-margin-top:110px}' +
    '.svc-cat-title{font-size:clamp(1.4rem,2.4vw,1.9rem);font-weight:800;letter-spacing:-.02em;margin:0 0 16px}';
  document.head.appendChild(st);
})();
